// @ts-nocheck
import GenericRenderContainerSection from './GenericRenderContainerSection';
import styled from 'styled-components';

const InfoRowDirection = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    column-gap: 10px;
    color: white;
    font-size: 12px;
    text-align: center;

    & .title-info {
        width: 50%;
        font-weight: 800;
    }

    & .value-info {
        width: 50%;
        font-weight: 500;
        font-style: italic;
    }
`;

const InfoColumnDirection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    row-gap: 2px;
    color: white;
    font-size: 12px;
    margin-top: 10px;

    & .title-info {
        text-align: center;
        width: 100%;
        font-weight: 800;
    }

    & .value-info {
        text-align: center;
        width: 100%;
        font-weight: 500;
        font-style: italic;
    }
`;

function InfoFileWrestlerRender({ wrestlerData }) {
    return ( 
        <GenericRenderContainerSection 
            className='info-file-wrestler-render'
            width='80%'
            padding='10px'
        >
            {/* Altezza */}
            <InfoRowDirection className='info-row-direction altezza'>
                <span className='title-info'>Altezza:</span>
                <span className='value-info'>{wrestlerData.height} cm</span>
            </InfoRowDirection>

            {/* Peso */}
            <InfoRowDirection className='info-row-direction peso'>
                <span className='title-info'>Peso:</span>
                <span className='value-info'>{wrestlerData.weight} kg</span>
            </InfoRowDirection>

            {/* Luogo di nascita */}
            <InfoRowDirection className='info-row-direction luogo-di-nascita'>
                <span className='title-info'>Luogo di nascita:</span>
                <span className='value-info'>{wrestlerData.place_birth}</span>
            </InfoRowDirection>

            {/* Volto reale */}
            <InfoRowDirection className='info-row-direction volto-reale'>
                <span className='title-info'>Volto reale:</span>
                <span className='value-info'>{wrestlerData.real_face_name}</span>
            </InfoRowDirection>

            {/* Attivo */}
            <InfoRowDirection className='info-row-direction attivo'>
                <span className='title-info'>Attivo:</span>
                <span className='value-info'>{wrestlerData.is_active ? 'Si' : 'No'}</span>
            </InfoRowDirection>

            {/* Manager */}
            <InfoRowDirection className='info-row-direction manager'>
                <span className='title-info'>Manager:</span>
                <span className='value-info'>{wrestlerData.is_manager ? 'Si' : 'No'}</span>
            </InfoRowDirection>

            {/* Theme Music */}
            <InfoRowDirection className='info-row-direction theme-music'>
                <span className='title-info'>Theme Music:</span>
                <span className='value-info'>{wrestlerData.theme_music}</span>
            </InfoRowDirection>

            {/* Bio */}
            <InfoColumnDirection className='info-row-direction bio'>
                <span className='title-info'>Bio:</span>
                <span className='value-info'>{wrestlerData.bio}</span>
            </InfoColumnDirection>
        </GenericRenderContainerSection>
    );
}

export default InfoFileWrestlerRender;